import * as yup from "yup";

const skills = yup.array().of(yup.string()).nullable(true);

export const schemaIndex = yup.object().shape({
  category: yup
    .string()
    .transform((value) => (!value ? null : value))
    .nullable(true),
  title: yup
    .string()
    .transform((value) => (!value ? null : value))
    .nullable(true),
});

export const schemaShow = yup.object().shape({
  skills: yup.array().when("global", {
    is: false,
    then: skills.required("Select skill or enable global mode"),
    otherwise: skills,
  }),
  global: yup.boolean().required("Select skill or enable global mode"),
  category: yup.string().required("Category is required"),
  title: yup.string().required("Title is required"),
  url: yup.string().when("category", {
    is: "link",
    then: yup.string().required("URL is required"),
    otherwise: yup.string(),
  }),
  type: yup.string().when("category", {
    is: "embed",
    then: yup.string().required("Type is required"),
    otherwise: yup.string(),
  }),
  src: yup.string().when("category", {
    is: "embed",
    then: yup.string().required("Src is required"),
    otherwise: yup.string(),
  }),
  width: yup.number().when("category", {
    is: "embed",
    then: yup.number().max(1080, "Maximum 1080").nullable(true),
    otherwise: yup.number().max(1080, "Maximum 1080"),
  }),
  height: yup.number().when("category", {
    is: "embed",
    then: yup.number().max(720, "Maximum 720").nullable(true),
    otherwise: yup.number().max(720, "Maximum 720"),
  }),
});
